export const health = [
    {
        id: "content-health-trending",
        name: "トレンド",
        articles: [
            {
                id: "b5d84dfb-d80f-4ba1-ab4e-c33e255b3157",
                class: "columns-3-balanced",
                header: "マインドフルネス",
                url: "#",
                image: {
                    src: "assets/images/benjamin-child-rOn57CBgyMo-unsplash_448.jpg",
                    alt: "プレースホルダー",
                    width: "448",
                    height: "252",
                },
                meta: {
                    captions: "誰かが撮影した写真。",
                },
                title: "ミネアポリス・ロレムは大量のサピエンの喉まで。",
                type: "list",
                content: [
                    {
                        id: "ee44b675-85c6-4aa7-9ce5-5b37311297bb",
                        content: "フットボールの執行価格ジャスミンQuiver。ニスルソース。",
                    },
                    {
                        id: "a40135ff-bc16-4a53-b6b1-d25835703af4",
                        content: "今、人生のチャットのアルコールライフ要素を飲みますが、屋外資産。",
                    },
                    {
                        id: "d143d9d9-7c3f-4b36-ad47-f591783f1595",
                        content: "ナム直径ヌートゥアスロレム。サッカーでDUIの喉を発酵させ、臨床矢印を引っ張ります。",
                    },
                    {
                        id: "e89bebb4-484b-45f2-a87b-409a941436da",
                        content: "そして、飢えと醜い。子どもの塊には、チリの漫画のアキュムサンの質量が必要です。",
                    },
                ],
            },
            {
                id: "a1822776-68b2-4d24-95e2-917756de0c12",
                class: "columns-3-balanced",
                header: "最新の研究",
                url: "#",
                image: {
                    src: "assets/images/louis-reed-pwcKF7L4-no-unsplash_448.jpg",
                    alt: "プレースホルダー",
                    width: "448",
                    height: "252",
                },
                meta: {
                    captions: "誰かが撮影した写真。",
                },
                title: "しかし、彼はサッカーサラダのスペルレスライフなどのサッカーメンバーを望んでいます。",
                type: "list",
                content: [
                    {
                        id: "d71c34e3-6c8e-4097-92a4-efd8042a192e",
                        content: "宿題のウルトレシープールですが、醜い開発者。パキスタンは、現在の要素ファシリシスライオンでも生態学的でもありません。",
                    },
                    {
                        id: "e0ab9000-9eea-4f64-b6d2-9f5e1250c0f9",
                        content: "チャットキャリアの要素のチャンピオンシップ。ウルトレイシーは温度のためのバナナを悲しさせません。",
                    },
                    {
                        id: "66f25618-e649-4814-a546-6edcc036dcfe",
                        content: "各オルシとプロパガンダの著者。フットボールが嫌いなフットボールフェージャットプライスニブ。",
                    },
                    {
                        id: "7b68e99a-151f-4452-99c9-49be9b399c2a",
                        content: "執行では資金調達でしたが、パフォーマンスはゲートウェイロレムソフトのみでした。人生の開発者もこれまででもありません。",
                    },
                ],
            },
            {
                id: "0a522480-9f37-43e3-bbf2-c5398450a921",
                class: "columns-3-balanced",
                header: "健康な先輩",
                url: "#",
                image: {
                    src: "assets/images/esther-ann-glpYh1cWf0o-unsplash_448.jpg",
                    alt: "プレースホルダー",
                    width: "448",
                    height: "252",
                },
                meta: {
                    captions: "誰かが撮影した写真。",
                },
                title: "チョコレートは強化されていません。",
                type: "list",
                content: [
                    {
                        id: "1cb48e86-99fd-44f8-9ce6-016778eb35d2",
                        content: "どんな笑顔でもパフォーマンススカートが嫌いですが、は嫌いです。もを必要としません。",
                    },
                    {
                        id: "fa57210c-bd31-4f4a-a601-9f3546196b4f",
                        content: "それ自体がプレイヤーまたは支払われたレシピに。生命が地域の最大の直径を受け取らない限り。",
                    },
                    {
                        id: "e6e75564-56e0-4f87-9169-89f2820f7221",
                        content: "開発者は、メンバーでもメンバーでもありません。週末に綴られた綴りのバレーボール要素の喉に.",
                    },
                    {
                        id: "243d7680-08ba-41d8-bff5-b544667064e5",
                        content: "週末には、恐怖フットボールの滅菌地域としての直径。バレーボールもプールにすぎません。",
                    },
                ],
            },
        ],
    },
    {
        id: "content-health-latest-facts",
        name: "最新の事実",
        articles: [
            {
                id: "db2abfd6-b4d4-4237-850a-7f34de938739",
                class: "columns-3-balanced",
                header: "より多くの人生、しかしより良い",
                image: {
                    src: "assets/images/melissa-askew-8n00CqwnqO8-unsplash_448.jpg",
                    alt: "プレースホルダー",
                    width: "448",
                    height: "252",
                },
                meta: {
                    captions: "誰かが撮影した写真。",
                },
                title: "しかし、タイムポットと震えの質量ウルトレシーmi。",
                type: "list",
                content: [
                    {
                        id: "92f15b5f-f191-4636-b197-b65b2fead08f",
                        content: "またはチケットが今必要です。フットボールFネットワークレシピ。",
                    },
                    {
                        id: "fe2aad93-2770-4068-aec3-ed5d630e47ec",
                        content: "サッカーサラダなどのサッカーメンバーをお願いします。選手のみのチョコレートフットボールバスケットボールの漫画層。",
                    },
                    {
                        id: "0f098b80-ec85-4de3-b0d4-4288947febaa",
                        content: "フットボールの執行価格ジャスミンQuiver。ullamcorperニンジン笑顔は必要ありません。",
                    },
                ],
            },
            {
                id: "8cfeff8c-94cb-4eca-b5e2-b4214b761705",
                class: "columns-3-balanced",
                header: "あなたがそれを逃した場合に備えて",
                image: {
                    src: "assets/images/marcelo-leal-6pcGTJDuf6M-unsplash_448.jpg",
                    alt: "プレースホルダー",
                    width: "448",
                    height: "252",
                },
                meta: {
                    captions: "誰かが撮影した写真。",
                },
                title: "バニープライスエーンQuiverは大きい。",
                type: "text",
                content:
                    "レクスマイクロ波lソースIDは、生命のソースによって滅菌されました。開発者は常にがバレーボールマイクロワを紹介します.\n\n誰でもバスケットボールの妊娠臨床を強調します。私はバスケットボールのかしいアルコールが好きではありません。栄養居住者サッカー悲しい古いオールドとネタスとマレスアダの飢er。",
            },
            {
                id: "ae3f3c45-b7fe-4729-8374-f3ba8d11eeff",
                class: "columns-3-balanced",
                header: "宇宙と科学",
                image: {
                    src: "assets/images/nasa-cIX5TlQ_FgM-unsplash_448.jpg",
                    alt: "プレースホルダー",
                    width: "448",
                    height: "252",
                },
                meta: {
                    captions: "誰かが撮影した写真。",
                },
                title: "彼の初心者による私たちの結婚をひねるクラス・タキトゥス・ソシオック。",
                type: "list",
                display: "bullets",
                content: [
                    {
                        id: "31fa8504-b3e7-4f33-bce6-d5e63c0e5c36",
                        content: "常に都市ソースの地球で宿題が必要です。",
                        url: "#",
                    },
                    {
                        id: "c86d479a-2603-4b7e-9f8e-c6c2482f1600",
                        content: "バナナはマイクロ波NソースIDを選択しました。屋外チョコレートはそうではありません。",
                        url: "#",
                    },
                    {
                        id: "3793f895-bcf1-4213-91a9-8efb79395dbc",
                        content: "臨床矢のケアを設定するものは何もありません。",
                        url: "#",
                    },
                    {
                        id: "8da08881-849b-4a8c-8890-89c56028c6cd",
                        content: "栄養学部のコンビニエンス開発者のサッカー。チャンピオンシップは、さまざまなものや震え、またはチケットで飲みます。ネットワークレシピ。",
                        url: "#",
                    },
                ],
            },
        ],
    },
    {
        id: "content-health-medical-breakthroughs",
        name: "医療ブレークスルー",
        articles: [
            {
                id: "2afaf4ee-4d1c-4f54-a970-bc8222cc3090",
                class: "columns-3-wide",
                header: "外科的発明",
                url: "#",
                image: {
                    src: "assets/images/national-cancer-institute-A2CK97sS0ns-unsplash_684.jpg",
                    alt: "プレースホルダー",
                    width: "684",
                    height: "385",
                },
                meta: {
                    captions: "誰かが撮影した写真。",
                    tag: {
                        type: "breaking",
                        label: "速報",
                    },
                },
                title: "長い時間が多すぎる場合。コースが必要なのは、いくつかのサラダ生態学的にチョコレート漫画モーリスが必要です。",
                type: "text",
                content:
                    "楽観的な生活が必要です。唐辛子の喪を与えるために。アースメイクアップセラミック栄養のサッカー開発者温度があります。醜い今はロアムの痛みが必要ですが。ターゲットを絞ったバスケットボールは今、プロパガンダ車です。バレーボールの要素以上のものもそうではありません。は今、チョコレートが必要です。",
            },
            {
                id: "7213a42c-c2eb-486a-bb2e-b59f6667fb4a",
                class: "columns-3-narrow",
                header: "メディケア",
                url: "#",
                image: {
                    src: "assets/images/national-cancer-institute-NFvdKIhxYlU-unsplash_336.jpg",
                    alt: "プレースホルダー",
                    width: "336",
                    height: "189",
                },
                meta: {
                    captions: "誰かが撮影した写真。",
                },
                title: "明日は常にオクトルまたは人生です。または、醜い今はロアムの痛みが必要ですが、今すぐ自分を引っ張ってください。",
                type: "text",
                content:
                    "このコースの漫画地域です。喉とテレビとEUですが、卒業しました。ジャスミンの価格は大きくなり、。キャンセル抗酸化物質のキャンセルモーリスは、ライフソースのアメットマスを座らせます.\n\nムーアはマウスを逃すために生まれます。醜いランニングのバスケットボールピーナッツ。さまざまなものや震えまたはチケットで飲みます。喪に服した滅菌された段階的な大規模な生態学的なポット航空会社の痛みの範囲。",
            },
            {
                id: "9323f56f-d3b3-4b86-bd4c-014392b62272",
                class: "columns-3-narrow",
                header: "投薬",
                url: "#",
                image: {
                    src: "assets/images/myriam-zilles-KltoLK6Mk-g-unsplash_336.jpg",
                    alt: "プレースホルダー",
                    width: "336",
                    height: "189",
                },
                meta: {
                    captions: "誰かが撮影した写真。",
                },
                title: "ニンジン補給学部開発者。彼は、チョコレートが強化されていないことを望んでいます。",
                type: "text",
                content:
                    "テレビ栄養箱をターゲットにしたテレビ。しかし、プロパガンダ車は全国の生活から抜け出します。は、生命が地域をとらない限り、現在融資しています。は妊娠中のアルコールをチャットしません。チョコレートフットボールバスケットボールのキャリア著者。\n\n整数のライフセラピーには、素晴らしいウォームアップワークのサッカーが必要です。ソリシジンと臨床的ナムの貧困。予約済みマイクロ波無料写真が時々写真を撮る。",
            },
        ],
    },
    {
        id: "content-health-latest-videos",
        name: "最新のビデオ",
        articles: [
            {
                id: "c1f811ca-284b-4e7b-9bfb-bb5a7c72211d",
                class: "columns-1",
                type: "grid",
                content: [
                    {
                        id: "f0e9befa-3d54-4a26-8267-0e38bb0eaa49",
                        image: {
                            src: "assets/images/mufid-majnun-J12RfFH-2ZE-unsplash_684.jpg",
                            alt: "プレースホルダー",
                            width: "684",
                            height: "385",
                        },
                        meta: {
                            tag: {
                                type: "watch",
                                label: "時計",
                            },
                        },
                    },
                    {
                        id: "e301a866-edd4-47a4-a4a6-ce4035c2ab74",
                        image: {
                            src: "assets/images/irwan-rbDE93-0hHs-unsplash_684.jpg",
                            alt: "プレースホルダー",
                            width: "684",
                            height: "385",
                        },
                        meta: {
                            tag: {
                                type: "watch",
                                label: "時計",
                            },
                        },
                    },
                    {
                        id: "329f6075-3a95-4a20-b3e1-ade5734544b4",
                        image: {
                            src: "assets/images/hyttalo-souza-a1p0Z7RSkL8-unsplash_684.jpg",
                            alt: "プレースホルダー",
                            width: "684",
                            height: "385",
                        },
                        meta: {
                            tag: {
                                type: "watch",
                                label: "時計",
                            },
                        },
                    },
                    {
                        id: "50b6d145-34da-4a7a-8f3f-bb1674a7692b",
                        image: {
                            src: "assets/images/jaron-nix-7wWRXewYCH4-unsplash_684.jpg",
                            alt: "プレースホルダー",
                            width: "684",
                            height: "385",
                        },
                        meta: {
                            tag: {
                                type: "watch",
                                label: "時計",
                            },
                        },
                    },
                ],
            },
        ],
    },
    {
        id: "content-health-educational",
        name: "教育",
        articles: [
            {
                id: "c2dc8f88-8a0a-4a3f-aadd-a5f83e291081",
                class: "columns-1",
                type: "grid",
                display: "grid-wrap",
                content: [
                    {
                        id: "994fb978-2024-4c58-a1e8-f19e8493c703",
                        image: {
                            src: "assets/images/bruno-nascimento-PHIgYUGQPvU-unsplash_448.jpg",
                            alt: "プレースホルダー",
                            width: "448",
                            height: "252",
                        },
                        meta: {
                            tag: {
                                type: "new",
                                label: "新しい",
                            },
                        },
                        text: "バレーボールまたはLaoreetマッサージが時々強化されました。プールまたは酸化防止剤の週末の漫画のメーセナス層。テクノロジーテクニックまたはツアーも選択されています。",
                        url: "#",
                    },
                    {
                        id: "4c2254af-2e9a-4249-a467-112211c41698",
                        image: {
                            src: "assets/images/brooke-lark-lcZ9NxhOSlo-unsplash_448.jpg",
                            alt: "プレースホルダー",
                            width: "448",
                            height: "252",
                        },
                        meta: {
                            tag: {
                                type: "new",
                                label: "新しい",
                            },
                        },
                        text: "電子レンジが無料で写真があり、時には可変ニンジンがあります。谷はサッカーライオンポットの従業員を設定しました。ミネアポリス・ロレムは大量のサピエンの喉とテレビとまで。アークランニングパフォーマンス。",
                        url: "#",
                    },
                    {
                        id: "a49d65ba-d42c-4b35-8926-479a8988d232",
                        image: {
                            src: "assets/images/kelly-sikkema-WIYtZU3PxsI-unsplash_448.jpg",
                            alt: "プレースホルダー",
                            width: "448",
                            height: "252",
                        },
                        meta: {
                            tag: {
                                type: "new",
                                label: "新しい",
                            },
                        },
                        text: "しかし、開発者はール製造はありますが、アークはパフォーマンススカートを嫌いではありません。マグナには顧客のニンジンが強化されています。この地域では、今のところは喉がバリエッドサッカーである整数euチョコレート。無料で。",
                        url: "#",
                    },
                    {
                        id: "c6f55f29-6b48-433d-85d1-0c952a01fa00",
                        image: {
                            src: "assets/images/robina-weermeijer-Pw9aFhc92P8-unsplash_448.jpg",
                            alt: "プレースホルダー",
                            width: "448",
                            height: "252",
                        },
                        meta: {
                            tag: {
                                type: "new",
                                label: "新しい",
                            },
                        },
                        text: "サッカーの時間ターゲットポットプール。寿命マクロソースラシニアの必須ミサ1つ以上。ランニングロケモーリスレンジジャスミンを実現します。テクノロジーチュートリアルプレーヤーの価格またはベッドの価格。素晴らしい妊娠中の男性がたくさんいます。",
                        url: "#",
                    },
                    {
                        id: "720a4102-5a8f-4825-ae68-e1d21a69d71a",
                        image: {
                            src: "assets/images/sj-objio-8hHxO3iYuU0-unsplash_448.jpg",
                            alt: "プレースホルダー",
                            width: "448",
                            height: "252",
                        },
                        meta: {
                            tag: {
                                type: "new",
                                label: "新しい",
                            },
                        },
                        text: "バニー整数はバナナを必要としています現在のタンクは素晴らしいです。これが喉の主な唐辛子です。栄養学部のコンビニエンス開発者をターゲットにしたテレビ。カートンチョコレートの直径はありません。フットボールフットボールの週末は抗酸化物質のモーリスが嫌いです。",
                        url: "#",
                    },
                ],
            },
        ],
    },
    {
        id: "content-health-fitness",
        name: "フィットネス",
        articles: [
            {
                id: "4e6716eb-0430-49b0-9d95-352333d760a0",
                class: "columns-wrap",
                header: "カロリーを燃やします",
                type: "excerpt",
                content: [
                    {
                        id: "930209e6-9f95-49c2-b5e7-1b4b8024fc8b",
                        image: {
                            src: "assets/images/scott-webb-U5kQvbQWoG0-unsplash_150.jpg",
                            alt: "プレースホルダー",
                            width: "150",
                            height: "84",
                        },
                        text: "各矢印唐辛子はあなたの週末の写真です。レイヤーのニンジンの資金調達では、ファシリシはありません。タンクとバニーとして飲むように倒れます。マウス重要なのは、地域の整数でです。",
                    },
                    {
                        id: "85789d48-e369-43a0-998c-5cc9af9256eb",
                        image: {
                            src: "assets/images/sven-mieke-Lx_GDv7VA9M-unsplash_150.jpg",
                            alt: "プレースホルダー",
                            width: "150",
                            height: "84",
                        },
                        text: "サッカーは笑顔の弓ではなく、他の誰よりも多様です。バナナ、航空会社のプールはないからです。大衆開発者に現在バレーボールに資金を提供しています。今、サッカー選手への時間、私の非常に喉の人生のバナナ。レシピは常に無料で引っ張ってください。",
                    },
                    {
                        id: "a8c8607f-8178-4b37-954a-d1578ae6624a",
                        image: {
                            src: "assets/images/geert-pieters-NbpUM86Jo8Y-unsplash_150.jpg",
                            alt: "プレースホルダー",
                            width: "150",
                            height: "84",
                        },
                        text: "学部の飲み物は、男性全体の補償です。この十分の道を走っている妊娠中の妊娠。質量ですが、時間のバニーの要素ですが。声明の屋外チョコレートまたは拡張。ウォームアップにももありません.",
                    },
                ],
            },
            {
                id: "056698a8-0ac8-4342-9e67-25993d574866",
                class: "columns-wrap",
                header: "ジムのお気に入り",
                type: "excerpt",
                content: [
                    {
                        id: "a43f2dd1-ac0d-4ba1-81ef-3fcaf359b5fc",
                        image: {
                            src: "assets/images/boxed-water-is-better-y-TpYAlcBYM-unsplash_150.jpg",
                            alt: "プレースホルダー",
                            width: "150",
                            height: "84",
                        },
                        text: "ランニングから自体はありません。誰もがいない限り、バスケットボールまたはフットボールのジャスミンのパフォーマンス要素。栄養質量の屋外パフォーマンス。ポットまたは開発者のウォームアップ層では、常に存在します。",
                    },
                    {
                        id: "67b4bee9-5248-45b5-98ed-aeadc2a33466",
                        image: {
                            src: "assets/images/jonathan-borba-lrQPTQs7nQQ-unsplash_150.jpg",
                            alt: "プレースホルダー",
                            width: "150",
                            height: "84",
                        },
                        text: "メインワークの補給学部開発者の宿題の悲しいケア。リスクが都合の時に言った。キーボードを必要としないものはありません。ストリートは、各矢印唐辛子ニンジンの週末の写真撮影を行います。",
                    },
                    {
                        id: "e182116f-dff8-4fcf-acb8-b7743e2cbdd2",
                        image: {
                            src: "assets/images/mr-lee-f4RBYsY2hxA-unsplash_150.jpg",
                            alt: "プレースホルダー",
                            width: "150",
                            height: "84",
                        },
                        text: "しかし、は、週末のメーセナスを持っていることを嫌います。笑い声を上げる学部生。臨床は、マイクの価格漫画を作ってください。直径ニンジンプレーヤー。ポットまたは開発者は常にニブを紹介します。",
                    },
                ],
            },
            {
                id: "389c5495-b37c-423f-8950-a1845317e41c",
                class: "columns-wrap",
                header: "ピラティス",
                type: "excerpt",
                content: [
                    {
                        id: "7bd49e3d-06fc-4195-99bc-3f604de242b3",
                        image: {
                            src: "assets/images/ahmet-kurt-WviyUzOg4RU-unsplash_150.jpg",
                            alt: "プレースホルダー",
                            width: "150",
                            height: "84",
                        },
                        text: "大量のウリシーズ、消費者マグナをヘンドレリットする私の男。人生の計画モーリスの賢いジャスミンまたは開発者チョコレート。バニー生態学的な栄養価の高い熱控除可能なルート酸塩の価格まで。",
                    },
                    {
                        id: "f41e3b74-a33d-4169-b604-099da64e24fb",
                        image: {
                            src: "assets/images/stan-georgiev-pvNxRUq7O7U-unsplash_150.jpg",
                            alt: "プレースホルダー",
                            width: "150",
                            height: "84",
                        },
                        text: "質量は、地域要素にとって現実的ではありません。醜い大量開発者DUIを実行するピーナッツ。いくつかの唐辛子ニンジンを手に入れるための主流の補給学部開発者。それにもかかわらず、それは多くの関心だけではありません。",
                    },
                    {
                        id: "5bc866c7-7d7e-44ef-bc98-4c68739be329",
                        image: {
                            src: "assets/images/ahmet-kurt-5BGg2L5nhlU-unsplash_150.jpg",
                            alt: "プレースホルダー",
                            width: "150",
                            height: "84",
                        },
                        text: "恐怖のブルプタートフットボールチョコレートトリガーファイナンス樹脂のエネナティス地域。サッカーでは、私の飲み物または執行パスポート各法執行機関。飲み物は、マネージャー全体のウルトリシーです。バナナの瞬間は抗酸化物質のために飲みます。スマートチリの素晴らしいエコロジカルポット航空会社の範囲は存在しません。",
                    },
                ],
            },
        ],
    },
    {
        id: "content-health-guides",
        name: "ガイド",
        articles: [
            {
                id: "9a1282a2-e227-4d96-8f3e-99c580f2939a",
                class: "columns-3-balanced",
                header: "50歳以降の健康",
                type: "articles-list",
                content: [
                    {
                        id: "efcabc5f-f52d-47c4-9f94-8bd780882b7a",
                        title: "そして、レシピが常に無料療法のために引っ張るので。",
                        content:
                            "プールの製造がありますが、アークはパフォーマンススカートを嫌いではありません。サッカー開発者のプロパガンダとして、サラダの生態学的な漫画モーリス。どちらもこの地域には多くのことではありません。あなたが嫌うまでパスポートフットボールの写真とサッカー。ライフサピエン栄養居住者サッカー悲しい老年。",
                    },
                    {
                        id: "2a62c03f-5073-424f-aab5-c0b7e25ae988",
                        title: "ニンジン航空会社には、賢い病気や弧の笑い声が必要です。",
                        content: "発酵とケアで妊娠しています。サッカー選手の直径のソリシジン。電子レンジが無料で写真があり、時には可変ニンジンがあります。現在、バレーボールマイクロ波無料。スカート任意またはピーナッツまで。",
                    },
                    {
                        id: "c8886351-2d3f-422c-a24e-85a3ac682673",
                        title: "ニシュルニシュルニスタンスニス。",
                        content: "恐怖の滅菌領域から滅菌された領域。レイヤーマクロセットAC。現在ふもとにある。学部の悲しい笑顔またはウォームアップのまでの直径。痛みの病気は、みんなのように揃っている笑顔の弓ではありません。",
                    },
                ],
            },
            {
                id: "7b268ec3-8ac2-42fc-ab0f-ac650d2493f1",
                class: "columns-3-balanced",
                header: "健康な心",
                type: "articles-list",
                content: [
                    {
                        id: "ee5dd7b7-30a1-48a9-92c4-9f605ec1d156",
                        title: "彼のパートナーを妊娠し、光線と山の大きな押しを引いています。",
                        content: "航空会社の大量IDやサッカーの一部はありません。抗酸化物質がたくさんない限り、何もありません。人生の醜い質量ですが、要素期間。メインロレムでのさまざまな宿題。レシピは常に無料で引っ張ってください。",
                    },
                    {
                        id: "74b09799-d0be-4e52-9bb9-748cde4af833",
                        title: "ニンジンになるのに多くの時間だけではありませんが、多くの時間です。",
                        content:
                            "しかし、プロパガンダには、アークがさまざまな宿題をする必要があります。子供はタンクとバニーとして飲み物を引き起こします。時間のバニーの要素ですが、スマイルの価格はよりも。パフォーマンスランニング。現在のSADグレートは、妊娠中の男性の主流です。",
                    },
                    {
                        id: "9e31db8f-9fba-4a1f-99f8-101e357802b4",
                        title: "に直径が拡張されるまで、多くの治療。",
                        content: "滅菌領域の週末の直径ではありません。は今ですが、無料の週末に座ってください。直径の滑ブルプタートまで多くのもの。住民のソースによって滅菌されたソース。",
                    },
                ],
            },
            {
                id: "f3907983-9885-4211-8878-0f85750bbaa7",
                class: "columns-3-balanced",
                header: "健康的な消化",
                type: "articles-list",
                content: [
                    {
                        id: "d70c020f-dec2-4903-bba0-3b20bed16068",
                        title: "一部のティーンエイジャーを恐れます、私の愛する人は気にしません。",
                        content: "メンバーはあなたのプレイヤーチリでもあります。開発者のサッカーの大衆には、チリの漫画層が施行されます。臨床サッカーカートンの要素ニブ楽しいテレビは今ではありません。整数のバレーボール要素の喉にはそうではありません。",
                    },
                    {
                        id: "b80ef050-df82-4ecb-ab98-d5311cae7a2a",
                        title: "宿題のウルトレシープールを投資しますが。直径牛肉まで。",
                        content:
                            "ソースは、命のソースのサピエンによって滅菌されます。EUバスケットボールのキャリアサッカープロパガンダの卒業生。バーウェンはサッカーをターゲットにしています。ティーンエイジャーを実行しています。明日はヴェネナティス、しかしサッカーは屋外での調査の矢を持っている必要があります.",
                    },
                    {
                        id: "bde5fc93-1779-4cf8-9d54-6ee9abfeb3c4",
                        title: "痛みの範囲は、抗酸化物質の現在の要素ではありません。",
                        content: "今、レシピは時々Variusです。非直径ナム製造ロレムセッドスマイルウルトレシー。しかし、枕マイクロ波妊娠局は卒業しました。チョコレートを除くプレイヤーにチリの漫画層が必要です。",
                    },
                ],
            },
        ],
    },
    {
        id: "content-health-underscored",
        name: "強調されています",
        articles: [
            {
                id: "851b619c-0d4b-478a-8991-d39394660b96",
                class: "columns-2-balanced",
                header: "これは最初です",
                type: "grid",
                content: [
                    {
                        id: "fcf0478b-f9e9-4e2c-abbf-0d02de98e891",
                        image: {
                            src: "assets/images/drew-hays-tGYrlchfObE-unsplash_336.jpg",
                            alt: "プレースホルダー",
                            width: "336",
                            height: "189",
                        },
                        meta: {
                            tag: {
                                type: "new",
                                label: "新しい",
                            },
                        },
                        text: "さまざまなアルコールドリンクでのチャンピオンシップ。しかし、それは常に局の妊娠中の化粧で笑顔です。非常にマッサージバスケットボールを妊娠しているタンクと執行として飲む。ゲートウェイがソフトな場合のパフォーマンス。さまざまなまたは震えまたはチケットで。",
                        url: "#",
                    },
                    {
                        id: "ae54f79f-a7d7-4887-99eb-0e52720a5529",
                        image: {
                            src: "assets/images/hush-naidoo-jade-photography-Zp7ebyti3MU-unsplash_336.jpg",
                            alt: "プレースホルダー",
                            width: "336",
                            height: "189",
                        },
                        meta: {
                            tag: {
                                type: "new",
                                label: "新しい",
                            },
                        },
                        text: "ジャスミンの価格は大規模で、製造業のレクトゥス・モーリスのバスケットボールを投資します。パッチが醜い開発者。サラダの生態学的順序でチョコレート漫画モーリスが必要になりました。ターゲットを絞ったプロテインバスケットボールですが。",
                        url: "#",
                    },
                ],
            },
            {
                id: "1080c9e5-4d40-4b28-9398-c03c9f94c74e",
                class: "columns-2-balanced",
                header: "この秒",
                type: "grid",
                content: [
                    {
                        id: "4bfb8bd6-9380-454d-9eae-17b6e6d311c8",
                        image: {
                            src: "assets/images/mathurin-napoly-matnapo-ejWJ3a92FEs-unsplash_336.jpg",
                            alt: "プレースホルダー",
                            width: "336",
                            height: "189",
                        },
                        meta: {
                            tag: {
                                type: "breaking",
                                label: "速報",
                            },
                        },
                        text: "時間ターゲットポットプール。学部生の履歴書として控除可能でない限り、要素。または、ライオンよりも選ばれた人の価格。サッカーのスコアのために明日の学部生がたくさん必要です.",
                        url: "#",
                    },
                    {
                        id: "53270566-3767-47b9-8a1e-da8ccef49491",
                        image: {
                            src: "assets/images/national-cancer-institute-KrsoedfRAf4-unsplash_336.jpg",
                            alt: "プレースホルダー",
                            width: "336",
                            height: "189",
                        },
                        meta: {
                            tag: {
                                type: "breaking",
                                label: "速報",
                            },
                        },
                        text: "矢印いくつかのマレスアダはアルコール寿命を飲みます。重要なのは、ライフマイクロ波プレイヤーCNNです。大衆不動産の宿題の子供たちのパフォーマンス。開発者は常にを紹介していませんが、バレーボールの履歴書もありません。航空会社の大量がないか。",
                        url: "#",
                    },
                ],
            },
        ],
    },
    {
        id: "content-health-what-to-eat",
        name: "何を食べれば良いか",
        articles: [
            {
                id: "8ed51654-db6a-4826-bd1c-25213bc4200b",
                class: "columns-wrap",
                header: "低炭水化物",
                type: "excerpt",
                content: [
                    {
                        id: "342206b9-9843-477a-b4d0-48cd160b56b2",
                        image: {
                            src: "assets/images/kenny-eliason-5ddH9Y2accI-unsplash_150.jpg",
                            alt: "プレースホルダー",
                            width: "150",
                            height: "84",
                        },
                        text: "酵母は鍋に置かれませんでした。震えがないのは嫌いです。これは、著者開発者であっても、超整備です。サッカーの明日の開発者はプロパガンダに住んでいます。",
                    },
                    {
                        id: "61be9558-b680-4a9c-b9fe-f17a3f58ff53",
                        image: {
                            src: "assets/images/brigitte-tohm-iIupxcq-yH4-unsplash_150.jpg",
                            alt: "プレースホルダー",
                            width: "150",
                            height: "84",
                        },
                        text: "したいのですが、時間はです。は、補給開発者の栄養住民を強化しました。利便性をキャンセルしますが、執行執行生態学的専門家。",
                    },
                    {
                        id: "91414131-2202-462c-84b3-cbf6bf66fb34",
                        image: {
                            src: "assets/images/brooke-lark-oaz0raysASk-unsplash_150.jpg",
                            alt: "プレースホルダー",
                            width: "150",
                            height: "84",
                        },
                        text: "栄養供与者。トマトではありませんでした。航空会社がないよりも直径として。チリのリレーと温度。チョコレートは病気に沿っています。",
                    },
                ],
            },
            {
                id: "692a6213-1024-4d3e-8e6d-34aed2bb3616",
                class: "columns-wrap",
                header: "ベジタリアン",
                type: "excerpt",
                content: [
                    {
                        id: "67db8a8e-9a39-4e2e-ba5a-7d57b0337fb0",
                        image: {
                            src: "assets/images/christina-rumpf-gUU4MF87Ipw-unsplash_150.jpg",
                            alt: "プレースホルダー",
                            width: "150",
                            height: "84",
                        },
                        text: "ただし、この十分の一通りの漫画地域。楽しいこともあれば。",
                    },
                    {
                        id: "f045c26c-eaf6-4192-b022-f4c00014caa8",
                        image: {
                            src: "assets/images/nathan-dumlao-bRdRUUtbxO0-unsplash_150.jpg",
                            alt: "プレースホルダー",
                            width: "150",
                            height: "84",
                        },
                        text: "明日の谷は常に著者または生涯です。バスケットボールで笑いを走らせて、私の時間の資金調達no。",
                    },
                    {
                        id: "02cbeb30-a5f2-4465-9a85-ae00007fd71a",
                        image: {
                            src: "assets/images/maddi-bazzocco-qKbHvzXb85A-unsplash_150.jpg",
                            alt: "プレースホルダー",
                            width: "150",
                            height: "84",
                        },
                        text: "エンティティのバレーボール要素の喉に、または週末に。空腹と醜いバニーですが、時間はurです。",
                    },
                ],
            },
            {
                id: "f264a46c-4e7e-4c9f-bf04-d4ed1fa6639a",
                class: "columns-wrap",
                header: "朝食",
                type: "excerpt",
                content: [
                    {
                        id: "719bbe3e-7a4b-4084-9bdd-8597a64d2c1c",
                        image: {
                            src: "assets/images/brooke-lark-IDTEXXXfS44-unsplash_150.jpg",
                            alt: "プレースホルダー",
                            width: "150",
                            height: "84",
                        },
                        text: "バイヤー最大の移民とバスケットボール。便利なクマの時点で期待して。サラダゼロQuiver直径へ。",
                    },
                    {
                        id: "05d98dcf-d7e5-4819-b22d-8a289eec2b61",
                        image: {
                            src: "assets/images/joseph-gonzalez-QaGDmf5tMiE-unsplash_150.jpg",
                            alt: "プレースホルダー",
                            width: "150",
                            height: "84",
                        },
                        text: "が醜い開発者ID調査の笑顔。直径はありません。私は妊娠したアークと温度サッカーのコンバリスジャスミンをチャットしません。",
                    },
                    {
                        id: "55d1073a-c733-4ca4-9ff1-e9ab2266ec84",
                        image: {
                            src: "assets/images/brooke-lark-GJMlSBS0FhU-unsplash_150.jpg",
                            alt: "プレースホルダー",
                            width: "150",
                            height: "84",
                        },
                        text: "最新のものにも委託がありました。臨床の価格は、マイクの価格漫画を作ってください。",
                    },
                ],
            },
        ],
    },
    {
        id: "content-health-hot-topics",
        name: "ホットな話題",
        articles: [
            {
                id: "dde55759-06c6-46bc-9f16-bed37ae3d77f",
                class: "columns-2-balanced",
                header: "これは最初です",
                type: "grid",
                content: [
                    {
                        id: "5e8ae348-e705-4be4-8e84-f09c3b2196dc",
                        image: {
                            src: "assets/images/national-cancer-institute-cw2Zn2ZQ9YQ-unsplash_336.jpg",
                            alt: "プレースホルダー",
                            width: "336",
                            height: "189",
                        },
                        meta: {
                            tag: {
                                type: "new",
                                label: "新しい",
                            },
                        },
                        text: "プロパガンダはさまざまなものでアルコール飲み物をベッドします。コース醜い大衆開発者DUI。Feugiatチョコレートは病気に沿っています。または臨床ゲートは枕ではありません。それはあなたが憎しみの弓を飾りたいと願うことです。必須の航空会社には、痛みの病気や笑顔の弧が必要です。サッカーのハロウィーン、私の飲み物またはバニー。",
                        url: "#",
                    },
                    {
                        id: "3ed555d2-4eb9-4263-84f8-8c7f973eae91",
                        image: {
                            src: "assets/images/national-cancer-institute-GcrSgHDrniY-unsplash_336.jpg",
                            alt: "プレースホルダー",
                            width: "336",
                            height: "189",
                        },
                        meta: {
                            tag: {
                                type: "new",
                                label: "新しい",
                            },
                        },
                        text: "震えの質量。ジャスミンを嫌いますが、顧客まで学部の直径を嫌います。今はソフトですが、それは常に局の笑顔です。今、それはフットボール選手の直径のケア時間です。トマトの学部開発者の宿題タンクの多く。",
                        url: "#",
                    },
                ],
            },
            {
                id: "17f26d05-24ef-4a12-80b0-611a43449aae",
                class: "columns-2-balanced",
                header: "この秒",
                type: "grid",
                content: [
                    {
                        id: "60c6fd49-f5af-4313-af21-a83cea3ce371",
                        image: {
                            src: "assets/images/national-cancer-institute-SMxzEaidR20-unsplash_336.jpg",
                            alt: "プレースホルダー",
                            width: "336",
                            height: "189",
                        },
                        meta: {
                            tag: {
                                type: "breaking",
                                label: "速報",
                            },
                        },
                        text: "そして、人生の開発者は常に人のベッドです。どちらでもない大衆の航空会社。しかし、サッカー、私の飲み物、または執行宿題の喉は醜いです。開発者ID調査では、恐怖の前でSmile feugiat。ビューロー妊娠中のメイクアップそれぞれまたはシリアルプロパガンダ。プロパガンダは、アークがさまざまな宿題をする必要があります。",
                        url: "#",
                    },
                    {
                        id: "f4873b14-4600-429e-b239-708aac5872d5",
                        image: {
                            src: "assets/images/national-cancer-institute-L7en7Lb-Ovc-unsplash_336.jpg",
                            alt: "プレースホルダー",
                            width: "336",
                            height: "189",
                        },
                        meta: {
                            tag: {
                                type: "breaking",
                                label: "速報",
                            },
                        },
                        text: "または支払った選択。ニンジンが強化されました。非直径ナム製造ロレムセッド笑い。門脈プールの嘆き層温度。サッカーは現在、子供のニンジン航空会社の喉です。または醜い今はロレムが必要です。予約済みマイクロ波無料。",
                        url: "#",
                    },
                ],
            },
        ],
    },
    {
        id: "content-health-paid-content",
        name: "有料コンテンツ",
        articles: [
            {
                id: "cbaac182-d046-43ee-b6d7-41a382e959ad",
                class: "columns-4-balanced",
                type: "preview",
                content: [
                    {
                        id: "c195937b-25a2-484b-8b0c-febfbae811b2",
                        image: {
                            src: "assets/images/dom-hill-nimElTcTNyY-unsplash_336.jpg",
                            alt: "プレースホルダー",
                            width: "336",
                            height: "189",
                        },
                        title: "フットボールサラダ素晴らしいウォームアップワークの人生。は大きく、製造業を卒業しました。必須の利便性リレーなし。",
                    },
                ],
            },
            {
                id: "ae883d3e-ef62-4f6e-ac2d-5555ca35f11a",
                class: "columns-4-balanced",
                type: "preview",
                content: [
                    {
                        id: "c5808643-c726-4249-9b1d-270e18dcc84b",
                        image: {
                            src: "assets/images/sarah-dorweiler-gUPiTDBdRe4-unsplash_336.jpg",
                            alt: "プレースホルダー",
                            width: "336",
                            height: "189",
                        },
                        title: "ヌラム車は、学校のコースからの訪問時の車両。地域の要素のために、生命とライオンの宿題の矢印。栄養開発者のニーズはありません。",
                    },
                ],
            },
            {
                id: "d8f20994-0098-4367-bc3a-131faa8f768d",
                class: "columns-4-balanced",
                type: "preview",
                content: [
                    {
                        id: "c27fac75-6c7c-4c26-9ac4-4f92c54e7308",
                        image: {
                            src: "assets/images/icons8-team-k5fUTay0ghw-unsplash_336.jpg",
                            alt: "プレースホルダー",
                            width: "336",
                            height: "189",
                        },
                        title: "開発者、および。最大の一部のマスカラニブで。サッカーだが妊娠中のチリ。エロスのプレイヤーでは、サピエンのヘアスタイルですが、恐怖のために時間を嘆きます。",
                    },
                ],
            },
            {
                id: "51f4b351-5916-4422-b661-61b65b911ee5",
                class: "columns-4-balanced",
                type: "preview",
                content: [
                    {
                        id: "05b1ce25-c066-4b9e-8a44-7a25dac28759",
                        image: {
                            src: "assets/images/jessica-weiller-So4eFi-d1nc-unsplash_336.jpg",
                            alt: "プレースホルダー",
                            width: "336",
                            height: "189",
                        },
                        title: "それは資金調達でしたが、パフォーマンスでしたが、ゲートでした。ヌラムと唐辛子の温度。臨床IDの価格。質量は、地域要素にとって現実的ではありません。",
                    },
                ],
            },
        ],
    },
];
